import {useNavigate, useSearchParams} from "react-router-dom";
import Routing from "../../Routing.ts";
import {ReactNode, useEffect, useState} from "react";

const UtmMapContentMap = new Map<string, string>([
    ['fiber-99-6mdr-hovedstadsomraadet', Routing.AlternativeFrontPages.TDCPaid],
    ['99-6mdr-tdc-net', Routing.AlternativeFrontPages.TDCPaid],
]);

const UtmSourceMap = new Map<string, string>([
    ['ida', Routing.AlternativeFrontPages.Ida],
    ['1167664433', Routing.AlternativeFrontPages.TjekBredbaand],
]);

function getPageBySearchParams(params: URLSearchParams) {
    const utm_content = params.get('utm_content');
    if (utm_content && UtmMapContentMap.has(utm_content)) {
        return UtmMapContentMap.get(utm_content);
    }

    const utm_source = params.get('utm_source');
    if (utm_source && UtmSourceMap.has(utm_source)) {
        return UtmSourceMap.get(utm_source);
    }

    return undefined;
}

export default function QueryParamRedirector({children}: { children: ReactNode }) {
    const [params] = useSearchParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const page = getPageBySearchParams(params)
        if (page !== undefined) {
            navigate(page + "?" + params.toString(), {replace: true})
            return
        }

        setLoading(false)
    }, [navigate, params])

    if (loading) {
        return
    }

    return children
}
